import { Component, OnInit } from '@angular/core';
import { MunicipalityDto, OverviewClient } from "@shared/clients/api.generated";
import { MapAreasMapping } from '@shared/components/map/map-styles.model';
import { SidenavigationLink } from '@shared/components/sidenavigation/sidenavigation.model';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import {
  ExtendedElectionDto,
  LatestUpdatesMunicipalityColumnDef,
  LatestUpdatesMunicipalityDto,
  NUMBER_OF_DIPLAYED_UPDATES
} from '../election-overview.model';
import { sortByAlphabeticallyIgnoreCase } from "../../../../utils/sort-utils";
import { TranslateService } from "@ngx-translate/core";
import { SidenavigationLinkType } from '@shared/components/page-layout/page-layout.model';
import { CountStatus } from "@shared/components/count-status/count-status.component";
import { ElectionOverviewService } from "../election-overview.service";
import { MapAreaClickedEvent } from "@shared/components/map/map-events.model";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'valg-dk-kv-election-overview',
  templateUrl: './kv-election-overview.component.html'
})
export class KvElectionOverviewComponent implements OnInit {

  election?: ExtendedElectionDto;

  readonly SvgIcon = SvgIcon;
  public mapAreasMapping?: MapAreasMapping;

  links: SidenavigationLink[] = [ ];

  countStatuses: CountStatus[] = [];
  sideNavTitleType = SidenavigationLinkType.Municipality;
  parentLinkType = SidenavigationLinkType.Region;
  childLinkType = SidenavigationLinkType.Municipality;

  latestUpdatesMunicipalityColumnDef = LatestUpdatesMunicipalityColumnDef;
  lastestUpdates: LatestUpdatesMunicipalityDto[] = [];

  municipalElectionOverview?: MunicipalityDto[];

  constructor(
    private readonly overviewClient: OverviewClient,
    private readonly electionOverviewService: ElectionOverviewService,
    private readonly translateService: TranslateService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    await this.initializeCurrentElection();
    this.initializeNavigationItems();
    this.initializeElectionOverview();
  }

  private mapCountStatuses(municipalElectionOverview: MunicipalityDto[]) {
    return municipalElectionOverview.map(municipality => {
      return {
        id: municipality.id,
        name: this.translateService.instant('election_overview.count_percent.municipality_name', { 'municipality': municipality.name }),
        percentage: municipality.countingPercentage
      }
    }) as CountStatus[];
  }


  private mapLatestUpdates(municipalElectionOverview: MunicipalityDto[]) {
    return municipalElectionOverview.map(municipality => {
      return {
        id: municipality.id,
        municipality: municipality.name,
        datetime: municipality.lastUpdate
      }
    }) as LatestUpdatesMunicipalityDto[];
  }

  private async initializeCurrentElection() {
    this.election = await this.electionOverviewService.getCurrentElection();
  }

  private initializeNavigationItems() {
    this.overviewClient.getElectionSideNavigation().subscribe((result) => {
      this.links = this.electionOverviewService.mapMunicipalSideNavigation(result, this.election);
    });
  }

  private initializeElectionOverview() {
    this.overviewClient.getMunicipalElectionOverview().subscribe((result) => {
      this.municipalElectionOverview = result.municipalities;
      this.mapAreasMapping = this.electionOverviewService.toMapAreaMapping(result.mapAreas);

      this.countStatuses = this.mapCountStatuses(this.municipalElectionOverview)
        .sort((a, b) => sortByAlphabeticallyIgnoreCase(a.name, b.name));

      this.lastestUpdates = this.mapLatestUpdates(this.municipalElectionOverview).slice(0, NUMBER_OF_DIPLAYED_UPDATES);
    });
  }

  private getMunicipalityDetailPageLink(municipalityId: string) {
    return `municipality/${municipalityId}`;
  }

  async onAreaClick($event: MapAreaClickedEvent) {
    const id = $event.data?.id;
    if (id) {
      const link = this.getMunicipalityDetailPageLink(id);
      await this.router.navigate([ link ], {
          relativeTo: this.route,
        }
      );
    }
  }
}
